import { has, isArray, isNumber } from 'lodash';
import { ProposalTableRowProps } from './type';
import { ProposalTableColumnFieldTypes, ProposalTableFieldType } from '@/src/shared/schemas';
import { PROPOSAL_TABLE_KEY, ProposalDataType, ProposalTableColumnsKeys, ProposalTableRowsKeys } from './const';


interface GetColumnCellProps {
    proposalData: ProposalDataType,
    rowKey?: ProposalTableRowProps['key'],
    columnIndex: number | null
    daysAbroad?: number
}

interface GetFieldNameProps {
  columnId?: string | null,
  fieldName: number | string | null,
}

export function getColumnCell({ proposalData, rowKey, columnIndex, daysAbroad = 0 }: GetColumnCellProps): { columnId: string, fields: ProposalTableFieldType[] } | null {
  if (rowKey && has(proposalData, rowKey) && isNumber(columnIndex)) {
    const selectedColumn = proposalData[rowKey][columnIndex];
    const fieldsKey = daysAbroad < 31 ? 'fields_to_30' : 'fields';
    return {
      columnId: selectedColumn.columnId,
      fields: selectedColumn[fieldsKey] || selectedColumn.fields,
    }
  }
  return null;
}

export const getFieldName = ({
  columnId,
  fieldName,
}: GetFieldNameProps) => `${PROPOSAL_TABLE_KEY}.${columnId}.${fieldName}`;

export const getColContextValueString = (columnId: string) => `${columnId}_req_data`;

export const getDefaultProposalData = (
  proposalData: ProposalDataType,
  variable: string,
  selectedColumnIndex: number,
) => {
  for (const rowKey in proposalData) {
    const rowValue = proposalData[rowKey as ProposalTableRowsKeys];
    if (isArray(rowValue)) {
      const row = rowValue[selectedColumnIndex];
      if (row && row.fields) {
        const field = row.fields.find((f) => f.name === variable);
        if (field) {
          return { label: field.label, value: field.value, type: field.type };
        }
      }
    }
  }
  return null;
};

export const runCallbackForFieldType = (
  columnData: Record<string, any> | undefined,
  fieldType: ProposalTableColumnFieldTypes,
  callback: (fieldKey: string) => void,
) => {
  if (!columnData) return;

  for (const key in columnData) {
    if (columnData[key]?.type === fieldType) {
      callback(key);
    }
  }
};

export const determinePickedCategory = ({ category, daysAbroad }: { category: ProposalTableColumnsKeys, daysAbroad: number }) => {
  console.log('Initial category:', category);
  console.log('Days abroad:', daysAbroad);

  if (
    daysAbroad <= 2 &&
    [ProposalTableColumnsKeys.Vip, ProposalTableColumnsKeys.Standard].includes(category)
  ) {
    return ProposalTableColumnsKeys.Business;
  }

  if (daysAbroad < 31 && category === ProposalTableColumnsKeys.Vip) {
    return ProposalTableColumnsKeys.Business;
  }

  if (daysAbroad >= 31 && category === ProposalTableColumnsKeys.Elit) {
    return ProposalTableColumnsKeys.Business;
  }

  return category;
}
